import styles from "./userGeneratedContent.module.scss";

declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace JSX {
    export interface IntrinsicElements {
      "jl-user-content": {
        productid: string;
        producturl: string;
        apiKey: string;
        clientId: string;
        carouselmaxwidthmobile: string;
        carouselmaxwidthtablet: string;
        carouselmaxwidthdesktop: string;
        experiences: string;
        isBrandPromiseActive: boolean;
      };
    }
  }
}

type Props = {
  /**
   * A string representing the product ID.
   */
  productId: string;
  /**
   * A string representing the URL of the product.
   */
  productURL: string;
  /**
   * A string representing the API key.
   */
  apiKey: string;
  /**
   * A string representing the client ID.
   */
  clientId: string;
  /**
   * A string representing the raw experiences.
   */
  experiencesRawString: string;
  /**
   * A boolean indicating whether the product is a brand promise.
   */
  isBrandPromise: boolean;
};

export const UserGeneratedContentUI = ({
  productId,
  productURL,
  apiKey,
  clientId,
  experiencesRawString,
  isBrandPromise,
}: Props) => (
  <div
    id="user-generated-content"
    data-testid="userGeneratedContent"
    className={styles.mobileNegativeMarginTop}
  >
    <jl-user-content
      productid={productId}
      producturl={productURL}
      apiKey={apiKey}
      clientId={clientId}
      carouselmaxwidthmobile="350"
      carouselmaxwidthtablet="400"
      carouselmaxwidthdesktop="600"
      experiences={experiencesRawString ? experiencesRawString : ""}
      isBrandPromiseActive={isBrandPromise}
    ></jl-user-content>
  </div>
);
